module.exports = __webpack_public_path__ + "static/media/mode-2002.ef4b178e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2002.svg
// module id = 1044
// module chunks = 2